// frontend/src/pages/RecoverPage.jsx
// Récupération de compte par phrase de 12 mots — styles inline uniquement.
import { useState } from "react";
import { Link } from "react-router-dom";

const s = {
  wrapper: {
    minHeight: "100vh",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    background: "#f9fafb",
    fontFamily: "system-ui, -apple-system, sans-serif",
    padding: "24px",
  },
  card: {
    background: "white",
    borderRadius: "12px",
    boxShadow: "0 2px 12px rgba(0,0,0,0.1)",
    padding: "36px 32px",
    width: "100%",
    maxWidth: "420px",
  },
  title: {
    fontSize: "22px",
    fontWeight: 700,
    color: "#1e293b",
    marginBottom: "8px",
  },
  subtitle: {
    fontSize: "13px",
    color: "#64748b",
    marginBottom: "28px",
    lineHeight: 1.6,
  },
  label: {
    display: "block",
    fontSize: "12px",
    fontWeight: 600,
    color: "#374151",
    marginBottom: "6px",
  },
  input: {
    width: "100%",
    padding: "10px 12px",
    border: "1.5px solid #CBD5E1",
    borderRadius: "8px",
    fontSize: "14px",
    background: "#F8FAFC",
    color: "#1e293b",
    boxSizing: "border-box",
    outline: "none",
    marginBottom: "16px",
    display: "block",
  },
  textarea: {
    width: "100%",
    padding: "10px 12px",
    border: "1.5px solid #CBD5E1",
    borderRadius: "8px",
    fontSize: "14px",
    background: "#F8FAFC",
    color: "#1e293b",
    boxSizing: "border-box",
    outline: "none",
    marginBottom: "16px",
    display: "block",
    resize: "vertical",
    minHeight: "80px",
    fontFamily: "inherit",
    lineHeight: 1.6,
  },
  btn: {
    width: "100%",
    padding: "12px",
    background: "#D41A6E",
    color: "white",
    border: "none",
    borderRadius: "8px",
    fontSize: "15px",
    fontWeight: 700,
    cursor: "pointer",
    marginBottom: "16px",
  },
  error: {
    background: "#fef2f2",
    border: "1px solid #fca5a5",
    borderRadius: "8px",
    padding: "10px 14px",
    color: "#dc2626",
    fontSize: "13px",
    marginBottom: "16px",
  },
  success: {
    textAlign: "center",
    padding: "12px 0",
  },
  successIcon: {
    fontSize: "48px",
    marginBottom: "16px",
  },
  successText: {
    fontSize: "16px",
    fontWeight: 600,
    color: "#16a34a",
    marginBottom: "8px",
  },
  successSub: {
    fontSize: "13px",
    color: "#64748b",
    marginBottom: "24px",
  },
  link: {
    color: "#D41A6E",
    textDecoration: "none",
    fontWeight: 600,
    fontSize: "14px",
  },
};

export default function RecoverPage() {
  const [step, setStep] = useState(1); // 1 = formulaire, 2 = succès
  const [username, setUsername] = useState("");
  const [recoveryPhrase, setRecoveryPhrase] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");

    try {
      const res = await fetch("/api/auth/recover", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          username: username.trim(),
          recovery_phrase: recoveryPhrase.trim(),
          new_password: newPassword,
        }),
      });

      const data = await res.json();

      if (!res.ok) {
        setError(data.error || `Erreur ${res.status}`);
        return;
      }

      setStep(2);
    } catch (err) {
      setError("Erreur réseau. Réessayez.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={s.wrapper}>
      <div style={s.card}>
        {step === 1 ? (
          <>
            <h1 style={s.title}>Récupérer mon compte</h1>
            <p style={s.subtitle}>
              Saisissez votre pseudonyme, vos 12 mots de récupération et choisissez un nouveau mot de passe.
            </p>

            {error && <div style={s.error}>{error}</div>}

            <form onSubmit={handleSubmit}>
              <label style={s.label}>Pseudonyme</label>
              <input
                type="text"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                placeholder="Votre pseudonyme"
                required
                style={s.input}
              />

              <label style={s.label}>Vos 12 mots de récupération</label>
              <textarea
                value={recoveryPhrase}
                onChange={(e) => setRecoveryPhrase(e.target.value)}
                placeholder="mot1 mot2 mot3 … mot12"
                required
                style={s.textarea}
              />

              <label style={s.label}>Nouveau mot de passe</label>
              <input
                type="password"
                value={newPassword}
                onChange={(e) => setNewPassword(e.target.value)}
                placeholder="Nouveau mot de passe"
                required
                minLength={6}
                style={s.input}
              />

              <button
                type="submit"
                disabled={loading}
                style={{ ...s.btn, opacity: loading ? 0.65 : 1, cursor: loading ? "not-allowed" : "pointer" }}
              >
                {loading ? "Vérification…" : "Réinitialiser le mot de passe"}
              </button>
            </form>

            <p style={{ textAlign: "center", fontSize: "13px", color: "#64748b" }}>
              <Link to="/login" style={s.link}>Retour à la connexion</Link>
            </p>
          </>
        ) : (
          <div style={s.success}>
            <div style={s.successIcon}>✅</div>
            <p style={s.successText}>Mot de passe réinitialisé.</p>
            <p style={s.successSub}>Vous pouvez maintenant vous connecter avec votre nouveau mot de passe.</p>
            <Link to="/login" style={{ ...s.btn, display: "inline-block", textDecoration: "none", textAlign: "center", padding: "12px 32px", width: "auto" }}>
              Se connecter
            </Link>
          </div>
        )}
      </div>
    </div>
  );
}
